import { isString } from './type-guards';

export const isValidEmail = (value: unknown): value is string =>
  isString(value) ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) : false;

export const toEmailUri = (value: string): string =>
  isValidEmail(value) ? `mailto:${value}` : ``;
